import { Colors, getPrice } from '@sigma-frontend-libs/commons'

import { components, services } from '@/utils'

import formatTable from '@/components/format/table'
import preloader from '@/components/preloader'
import { billingsStatuses } from '@/components/services/billings/utils'
import tag from '@/components/tag'

function renderPreloader(h) {
  return h(
    'div',
    {
      class: 'preloader__holder preloader__holder--absolute pa-5'
    },
    [ h(preloader) ]
  )
}
function renderAbsolutePreloader(h) {
  if (this.loading) {
    return h(
      'div',
      {
        class: 'preloader__holder preloader__holder--absolute'
      },
      [ h(preloader) ]
    )
  }
}

function renderSource(h, { source }) {
  const [ s, t ] = source.split('.')
  const type = t || s

  if (type) {
    return h(
      tag,
      {
        props: {
          label: this.getTranslate(`${services.billings}.sources.${type}`),
          color: type
        }
      }
    )
  }
}
function renderStatus(h, { status }) {
  if (status) {
    return h(
      tag,
      {
        props: {
          label: this.getTranslate(`${services.billings}.statuses.${status}`),
          color: billingsStatuses[status].color
        }
      }
    )
  }
}
function renderPrice(h, { amount }) {
  return h(
    tag,
    {
      props: {
        label: getPrice(amount),
        color: Colors.primary
      }
    }
  )
}
function renderItemHeader(h, item) {
  return h(
    'div',
    {
      class: `${services.sendings}-item__tabs-billings-item__header`
    },
    [
      renderSource.call(this, h, item),
      renderStatus.call(this, h, item),
      renderPrice.call(this, h, item)
    ]
  )
}
function renderItemBody(h, value) {
  return h(
    formatTable,
    {
      props: {
        value,
        service: services.billings
      }
    }
  )
}
function renderItem(h, item) {
  return h(
    'div',
    {
      class: `${services.sendings}-item__tabs-billings-item`
    },
    [
      renderItemHeader.call(this, h, item),
      renderItemBody.call(this, h, item)
    ]
  )
}
function renderItems(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-item__tabs-billings-items`
    },
    [
      this.items.map(item => {
        return renderItem.call(this, h, item)
      }),

      renderAbsolutePreloader.call(this, h)
    ]
  )
}
function renderBody(h) {
  if (Array.isArray(this.items) && this.items.length) {
    return renderItems.call(this, h)
  } else {
    switch (this.loading) {
      case true: return renderPreloader.call(this, h)
      case false:
      default: return h(components.empty)
    }
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-item__tabs-billings`
    },
    [ renderBody.call(this, h) ]
  )
}
